import Helpers from "@/helpers/helpers";

/**
 * Validates a comma-separated list of integer IDs.
 * Returns an error message string if invalid, or empty string if valid.
 */
export const validateIntegerList = (
  val: string,
  emptyMessage: string,
  formatMessage: string
): string => {
  if (Helpers.isEmpty(val)) return '';
  const items = val.split(",").map(item => item.trim());

  if (items.some(item => item === "")) {
    return emptyMessage;
  }

  if (items.some(item => !/^\d+$/.test(item))) {
    return formatMessage;
  }

  return '';
};
